// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2193) return "static/chunks/2193-63351db864440147.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1160":"a77c0a214e6cf3bb","3509":"e01e052f34366202","4095":"945653cac9b53d6e","5900":"c52da31ed2566f26","7247":"1687dd26c4d6a7b2","9890":"5da4e60d03e1c6f6"}[chunkId] + ".js";
};